var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Form',{attrs:{"tipoExameId":_vm.tipoExameId,"itens":_vm.itens}}),_c('rkm-area',{attrs:{"title":"Exames"}},[_c('List',{attrs:{"itens":_vm.itens}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }